import { useAppConstantsContext } from '@/context/AppConstants';
import { Link, Text, styled } from '@/theme/index';
import { CompliancePreviousPageButton } from './CompliancePreviousPageButton';

const HeaderContent = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  marginTop: theme.spacing(1.5),
}));

const FormTitleTag = styled('div')(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(3.2),
  padding: `0 ${theme.spacing(2)}`,
}));

type ComplianceFormHeaderProps = {
  link: string;
};

export function ComplianceFormHeader({ link }: ComplianceFormHeaderProps) {
  const {
    links: { tosLink },
  } = useAppConstantsContext();

  return (
    <>
      <HeaderContent>
        <CompliancePreviousPageButton link={link} />
      </HeaderContent>
      <FormTitleTag>
        <Text
          variant="h2"
          sx={{
            borderRadius: 0.5,
            padding: `${1.2} ${2.5}`,
            margin: 'auto',
            width: { sm: '50%', md: '90%' },
          }}
        >
          My use is permitted
        </Text>

        <Text variant="h3" mt={1.5}>
          <b>
            Complete this form to verify compliance with our{' '}
            <Link
              href={tosLink}
              target="_blank"
              rel="noopener"
              underline="always"
              color="success.main"
            >
              Terms of Service
            </Link>
            .
          </b>
        </Text>
      </FormTitleTag>
    </>
  );
}
